import CancelAppointmentSvg from '@assets/images/svg/cancel-appointment.svg';
import React from 'react';
import { View } from 'react-native';

export interface CancelAppointmentIconProps {
    size?: number;
    color?: string;
}

export function CancelAppointmentIcon({ size = 48, color = '#333333' }: Readonly<CancelAppointmentIconProps>) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CancelAppointmentSvg width={size} height={size} color={color} />
        </View>
    );
}

export default CancelAppointmentIcon;
